import angela from './team-images/angela.jpeg'
import luca from './team-images/luca.jpeg'
import nicolo from './team-images/niccolo.jpeg'
import william from './team-images/william.jpeg'
import giula from './team-images/giulia.png'
import ahmed from './team-images/ahmad.jpeg'
import kay from './team-images/kay.jpeg'
import yusuf from './team-images/yusuf.jpg'
import lea from './team-images/lea.jpg'
import carlo from './team-images/carlo.jpg'




const profiles = [
  {
    image: angela,
    name: "Angela Griggio",
    post: "Co-Founder, CEO",
    quote: "Pragmatic mind, unstoppable.",
    linkedInUrl: "https://linkedin.com/in/angela-griggio-30a6a0182",
    otherUrl: "",
    id: 1,
  },
  {
    image: luca,
    name: "Luca Eugenio Barlassina ",
    post: "Co-Founder, COO",
    quote: "Creative mind, always thinking outside the box.",
    linkedInUrl: "https://linkedin.com/in/luca-eugenio-barlassina-293077180",
    otherUrl: "https://github.com/Lord-Nymphis",
    id: 2,
  },
  // {
  //   image:ren,
  //   name: "Ren Okamoto",
  //   post: "Senior Blockchain Developer",
  //   quote: "",
  //   linkedInUrl: "https://www.linkedin.com/in/ren-okamoto-140a97224",
  //   otherUrl: "https://github.com/fantasy2345",
  //   id: 15,
  // },

  {
    image: nicolo,
    name: "Niccolò Baldini",
    post: "Blockchain Developer. Quality tester",
    quote: "Full time dad, coder and decentralized web enthusiast",
    linkedInUrl: "https://linkedin.com/in/niccol%C3%B3-baldini-0400baa9",
    otherUrl: "https://github.com/viac92",
    id: 3,
  },
  {
    image: lea,
    name: "Lea Narzis",
    post: "Senior Substrate deveoper",
    quote: "",
    linkedInUrl: "",
    otherUrl: "https://github.com/lean-apple",
    id: 4,
  },
  {
    image: kay,
    name: "Olukayode Alawiye ",
    post: "frontend engineer",
    quote:
      "Full-stack developer Fueled by high energy levels and boundless enthusiasm",
    linkedInUrl: "https://linkedin.com/in/alawiye-olukayode-aa365298",
    otherUrl: "https://github.com/oluseyi-frontend?tab=repositories",
    id: 5,
  },
  
  {
    image: william,
    name: "William Liu",
    post: "Senior Blockchain Developer",
    quote:
      "Highly proficient in object-oriented methodologies, data structures, algorithms, as well as quality coding and excellent debugging skills",
    linkedInUrl: "https://linkedin.com/in/william-liu-8a4672218/",
    otherUrl: "https://github.com/Crypto-One-dev",
    id: 6,
  },
  {
    image: yusuf,
    name: "Yusuf kelo",
    post: "Senior substrate developer",
    quote:
      "",
    linkedInUrl: "",
    otherUrl: "https://github.com/ysfkel",
    id: 7,
  },
  {
    image: giula,
    name: "Giulia Cortinovis",
    post: "Web Designer",
    quote: "A Pisces working hard to transform ideas in visual experiences",
    linkedInUrl: "https://linkedin.com/in/giulia-cortinovis-98702796",
    otherUrl: "",
    id: 8,
  },
  {
    image:ahmed,
    name: "Ahmed Abdel Al",
    post: "Graphic Designer",
    quote: "",
    linkedInUrl: "https://linkedin.com/in/ahmedabdelal",
    otherUrl: "http://www.ahmedabdelal.com/",
    id: 9,
  },

  {
    image:carlo,
    name: "Carlo Buonpane",
    post: "Chief Listing Officer",
    quote: "",
    linkedInUrl: "https://www.linkedin.com/in/carlo-buonpane-a9a44684/",
    otherUrl: "",
    id: 10,
  },

  
 
  
 
  
];




export default profiles